import { Box, Button, Grid, makeStyles, useMediaQuery, useTheme } from "@material-ui/core"
import { useParams, useNavigate } from "react-router-dom"
import NCText from "../../shared/NCText"
import TopNavBar from "../../components/TopNavBar"
import FormSection from "../../components/FormSection"
import NCLoader from "../../shared/NCLoader"
import NotificationAlert from "../../components/notification/NotificationAlert"
import NCAuditButton from "../../shared/NCAuditButton"
import { useGetGuardian, useGetGuardianAuditLog } from "../../services/queries"
import { loggedInUser } from "../../libs/utils"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles(() => ({
  button: {
    borderRadius: "20px",
    fontSize: "12px"
  },
  rowItem: {
    minWidth: 0
  },
  rowValue: {
    overflowWrap: "anywhere",
    wordBreak: "break-word"
  }
}))

const GuardianDetail = () => {
  const cls = useStyles()
  const { t } = useTranslation()
  const { guardianId } = useParams()
  const nav = useNavigate()
  const user = loggedInUser()

  const { isLoading, data } = useGetGuardian(guardianId)
  const guardianData = data?.data?.data || {}

  const { data: audit } = useGetGuardianAuditLog(guardianId, {
    enabled: guardianId && user?.user_type === 1 ? true : false
  })
  const guardianAuditData = audit?.data?.data?.results || []

  const mobileTheme = useTheme()
  const isSmallScreen = useMediaQuery(mobileTheme.breakpoints.down("sm"))

  const renderRowItem = (key, value) => {
    return (
      <Grid item xs={12} sm={6} md={4} className={cls.rowItem}>
        <NCText>
          <Box fontSize={"12px"} color={"#9CA3AF"}>
            {key}
          </Box>
        </NCText>
        <NCText variant="body2" block className={cls.rowValue}>
          {value || "-"}
        </NCText>
      </Grid>
    )
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Box mb={2}>
            <NCText variant={"h5"}>{t("guardian.guardian_details")}</NCText>
          </Box>
          <Box display={"flex"} alignItems={"flex-start"}>
            {!isSmallScreen && user.user_type === 1 && guardianId ? (
              <Box mb={2} mr={1}>
                <NCAuditButton data={guardianAuditData} isLoading={isLoading} />
              </Box>
            ) : null}
            <Box mb={2} mr={1}>
              <Button
                className={cls.button}
                variant="contained"
                color="primary"
                onClick={() => nav(`/guardians/edit/${guardianId}`)}
              >
                {t("guardian.edit_guardian")}
              </Button>
            </Box>
            <NotificationAlert />
          </Box>
        </Box>
      </Grid>
      {isSmallScreen && (
        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"flex-end"} mb={2}>
            {user.user_type === 1 && guardianId ? (
              <Box mr={1}>
                <NCAuditButton data={guardianAuditData} isLoading={isLoading} />
              </Box>
            ) : null}
          </Box>
        </Grid>
      )}
      <Grid item xs={12}>
        <Box>
          <TopNavBar />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <FormSection title={t("guardian.guardian_details")}>
          <Grid container spacing={2}>
            {renderRowItem(t("common.first_name"), guardianData?.first_name)}
            {renderRowItem(t("common.last_name"), guardianData?.last_name)}
            {renderRowItem(t("common.email_address"), guardianData?.email)}
            {renderRowItem(t("common.phone_number"), guardianData?.phone)}
          </Grid>
        </FormSection>
      </Grid>
      {isLoading && <NCLoader open={true} />}
    </Grid>
  )
}
export default GuardianDetail
